import qs from "qs";
import http from "../http";

function getTestCandidates(payload) {
  return http(
    "GET",
    `${window.API_URL}/test/candidates?taskId=${payload.taskId}&testStatuses=${payload.testStatuses}`
  );
}

function getTestList(payload) {
  const candidateTypes = payload.candidateTypes;
  const testStatuses = payload.testStatuses;
  delete payload.candidateTypes;
  delete payload.testStatuses;

  let url = `${window.API_URL}/test/list?${qs.stringify(payload)}`;
  if (candidateTypes) url += `&candidateTypes=${candidateTypes}`;
  if (testStatuses) url += `&testStatuses=${testStatuses}`;
  return http("GET", url);
}

function getTestPreparers(payload) {
  return http(
    "GET",
    `${window.API_URL}/test/preparers?${qs.stringify(payload)}`
  );
}

// Test 상태 변경
// T - 응시 미완료, E - 평가 필요, F - 불합격, P - 합격(담당자 배정 전), D - 합격(담당자 배정 완료)
function setTestsStatus(payload) {
  return http("PUT", `${window.API_URL}/tests/status`, payload);
}

// Test 조회 (for testspace)
function getTestInfo(payload) {
  const testId = payload.testId;
  delete payload.testId;
  return http(
    "GET",
    `${window.API_URL}/tests/${testId}?${qs.stringify(payload)}`
  );
}

function getTestItemId(payload) {
  return http(
    "GET",
    `${window.API_URL}/test/item/next?${qs.stringify(payload)}`
  );
}

function getTestItemInfo(payload) {
  return http("GET", `${window.API_URL}/test/items/${payload.testItemId}`);
}

function setTestItemStatus(payload) {
  return http("PUT", `${window.API_URL}/test/items/${payload.testItemId}`, {
    submitType: payload.submitType,
  });
}

function setSaveTestItem(payload) {
  return http(
    "PUT",
    `${window.API_URL}/test/items/${payload.testItemId}/answer`,
    {
      answer: payload.answer,
    }
  );
}

function getTestItems(payload) {
  return http(
    "GET",
    `${window.API_URL}/test/items/list?${qs.stringify(payload)}`
  );
}

function getTestPageInfo(payload) {
  return http(
    "GET",
    `${window.API_URL}/test/items/page?${qs.stringify(payload)}`
  );
}

function getTestSubmitters(payload) {
  return http(
    "GET",
    `${window.API_URL}/test/submitter/list?${qs.stringify(payload)}`
  );
}

function getTestProgress(payload) {
  return http("GET", `${window.API_URL}/tests/${payload.testId}/progress`);
}

function getTestNextSubmitter(payload) {
  return http(
    "GET",
    `${window.API_URL}/test/submitter/next?${qs.stringify(payload)}`
  );
}

export default {
  getTestCandidates,
  getTestList,
  getTestPreparers,
  setTestsStatus,
  getTestInfo,
  getTestItemId,
  getTestItemInfo,
  setTestItemStatus,
  setSaveTestItem,
  getTestItems,
  getTestPageInfo,
  getTestSubmitters,
  getTestProgress,
  getTestNextSubmitter,
};
